<template>
  <transition name="modal-fade">
    <div class="modal-mask" v-if="modal">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-content-wrapper">

            <div class="modal-header">
              <h3>{{ header || ""}}</h3>
            </div>

            <div class="modal-body">
              <slot>
                エラーが発生しました。
              </slot>
            </div>

            <div class="modal-controls">
              <button @click="close" class="modal-button">戻る</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: ['modal', 'header'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/style/modal_scss.scss";

.modal-wrapper {
  vertical-align: middle;
}
</style>
